<div class="formal-question-selector-backdrop" @click.self="$emit('close')">
  <div class="card border rounded-lg shadow formal-question-selector-modal">
    <div class="card-body p-3 p-lg-4 d-flex flex-column gap-4 formal-question-selector-body">
      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-start gap-3">
        <div>
          <p class="text-uppercase text-muted text-xxs mb-1">PDF Report Questions</p>
          <h4 class="text-x fw-bold mb-1">{{ modal_title }}</h4>
          <p class="text-muted text-xxs mb-0">
            Choose questions using the same staged selector as the normal report builder.
          </p>
        </div>
        <button
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          type="button"
          @click="$emit('close')"
        >
          Close
        </button>
      </div>

      <ReportBuilderDataSelectionStep
        :allow_selected_question_reorder="selection_mode === 'multiple'"
        :available_forms="available_forms"
        :empty_selected_questions_description="empty_selected_questions_description"
        :empty_selected_questions_title="empty_selected_questions_title"
        :filtered_questions="filtered_questions"
        :format_question_type="format_question_type"
        :get_allowed_metric_types="get_allowed_metric_types"
        :is_question_scope_report="true"
        :is_question_selected="is_question_selected"
        :is_question_statistics_summary="false"
        :is_select_type="is_select_type"
        :loading_forms="loading_forms"
        :loading_main_sections="loading_main_sections"
        :loading_questions="loading_questions"
        :loading_sub_sections="loading_sub_sections"
        :main_sections="main_sections"
        :non_question_scope_summary_description="''"
        :question_search="question_search"
        :selected_form_id="selected_form_id"
        :selected_main_section_id="selected_main_section_id"
        :selected_questions="selected_questions"
        :selected_questions_description="selected_questions_description"
        :selected_sub_section_id="selected_sub_section_id"
        :sub_sections="sub_sections"
        :translate_label="translate_label"
        @remove-question="remove_question"
        @reorder-selected-question="reorder_selected_question"
        @toggle-question-selection="toggle_question_selection"
        @update:question_search="question_search = $event"
        @update:selected_form_id="handle_form_selection"
        @update:selected_main_section_id="handle_main_section_selection"
        @update:selected_sub_section_id="handle_sub_section_selection"
      />

      <div class="d-flex justify-content-end gap-2 formal-question-selector-footer">
        <button
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          type="button"
          @click="$emit('close')"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          :disabled="!can_confirm_selection"
          type="button"
          @click="confirm_selection"
        >
          Use Selected Question<span v-if="selection_mode === 'multiple'">s</span>
        </button>
      </div>
    </div>
  </div>
</div>
